import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IBuilding } from 'src/app/building-managment/building-management-interfaces';
import { getFullName } from 'src/app/shared/utils/full-name.util';
import { PopupProfile } from '../profile-management.service';
import { AssignFloor, AssignUnit } from '../profile-assign-unit/profile-assign-unit.component';

@Component({
  selector: 'app-profile-access-unit-list',
  templateUrl: './profile-access-unit-list.component.html',
  styleUrls: ['../profile-assign-building/profile-assign-building.component.scss'],
})
export class ProfileAccessUnitListComponent {
  @Input() profileDetails!: PopupProfile;
  @Input() building?: IBuilding;
  @Input() floors: AssignFloor[] = [];
  @Input() dialogRef?: { close: () => void };
  @Output() stepperChange = new EventEmitter<number>();
  @Output() unitSelected = new EventEmitter<AssignUnit>();

  get userName(): string {
    const p = this.profileDetails;
    return getFullName(p?.firstName, p?.middleName, p?.lastName);
  }

  get units(): AssignUnit[] {
    return this.floors.reduce((units, floor) => units.concat(floor.units), [] as AssignUnit[])
      .sort((a, b) => a.unitName.localeCompare(b.unitName, undefined, { numeric: true }));
  }

  selectUnit(unit: AssignUnit): void {
    this.unitSelected.emit(unit);
    this.stepperChange.emit(34);
  }

  back(): void {
    this.stepperChange.emit(20);
  }

  close(): void {
    this.dialogRef?.close();
  }
}